export const LogoMark = ({ className = "", color = "#0F2137" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" stroke={color} strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 14H88" />
    <path d="M18 21H82" />
    <path d="M26 29C40 26 60 26 74 29" />
    <path d="M30 30C30 23 17 23 17 32C17 39 27 39 27 33C27 30 22 30 22 33" />
    <path d="M70 30C70 23 83 23 83 32C83 39 73 39 73 33C73 30 78 30 78 33" />
    <path d="M30 84V46C30 31 60 31 60 46V84" />
    <path d="M40 84V46C40 31 70 31 70 46V84" />
    <path d="M35 84V50M65 84V50" />
  </svg>
);
